<template>
  <div class="full-screen-container">
    <div class="full-screen">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.full-screen-container {
  background: $color-almost-black-20;
  overflow-x: hidden;
  overflow-y: auto;
  display: block !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  outline: 0;

  .full-screen {
    position: relative;
    width: auto;
    height: 100vh;
    margin: 0;
    max-height: 100vh;
    max-width: 100vw;
  }
}
</style>
